import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import SearchDropdownFilter from "./SearchDropdownFilter";
import JobType from "../../../model/job/JobType";

class JobTypeFilter extends SearchDropdownFilter<JobType> {

	itemToId(item: JobType): string {
		return item.id;
	}

	itemToLabel(item: JobType): string {
		return item.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.jobType.jobTypes
	};
}

export default connect(mapStateToProps)(JobTypeFilter)